import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../AppProvider";

const Navbar = () => {
    const { auth, userData, setAuth, setUserData } = useContext(AppContext);

    const handleLogout = () => {
		setAuth(null);
		localStorage.removeItem('auth');

		setUserData(null);
		localStorage.removeItem('userData');
	};

	const handleHardRefresh = () => {
        window.location.reload();
    };

    return (
        <>
        <div className="h-20 sm:hidden"></div>
        <nav className="navbar gap-4 fixed sm:static bg-base-100 sm:bg-transparent top-0 left-0">
            <div className="navbar-start flex-grow">
                {userData ? <>
                <div className="btn btn-ghost rounded-2xl w-full max-w-full flex justify-start">
                    <h1 className="truncate text-sm text-start leading-none flex flex-col">
                        <span className="block truncate text-sm">{userData.nama}</span>
                        <span className="block truncate text-xs">{userData.kode_kelas} - {userData.nis}</span>
                    </h1>
                </div>
                </> : 
                <>
                <h1 className="btn btn-ghost rounded-2xl text-xl">CBT Trikabta</h1>
                </> }
            </div>
            <div className="navbar-end w-auto">
                <div className="dropdown dropdown-end">
                    <div tabIndex="0" role="button" className="btn btn-ghost rounded-2xl">
                        <div className="indicator">
                            <i className="bi bi-three-dots-vertical text-xl"></i>
                        </div>
                    </div>
                    <ul tabIndex="0" className="dropdown-content menu bg-base-300 rounded-2xl z-[1] w-40 p-2 mt-2 shadow-2xl">
                        {auth && <li><a onClick={handleLogout}>Keluar</a></li> }
                        <li><a onClick={handleHardRefresh}>Hard Refresh</a></li>
                    </ul>
                </div>
            </div>
        </nav>
        </>
    );
}

export default Navbar;
